import {  AttributeCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  category_id: {
    'ui:widget': AttributeCategorySelectionWidget,
  },
});

export default uiSchema;
